export default "__VITE_PUBLIC_ASSET__33ec7a6d__"